import PageHeader from '@/components/feature/PageHeader';
import { Link } from 'react-router-dom';
import { episodes } from '@/mocks/episodes';
import { usePageMeta } from '@/hooks/usePageMeta';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'CollectionPage',
      name: '泡在我家的辣妹分集剧情',
      description: '泡在我家的辣妹分集剧情介绍与各话看点。',
      inLanguage: 'zh-CN',
      isPartOf: { '@type': 'WebSite', name: '泡在我家的辣妹资料站' },
    },
    {
      '@type': 'ItemList',
      name: '泡在我家的辣妹分集剧情列表',
      itemListElement: episodes.map((ep) => ({
        '@type': 'ListItem',
        position: ep.no,
        name: ep.title,
      })),
    },
  ],
};

export default function Episodes() {
  usePageMeta({
    title: '泡在我家的辣妹分集剧情 - 各话剧情梗概与看点',
    description:
      '泡在我家的辣妹分集剧情大全：逐话梳理剧情梗概与看点，帮你快速回顾关键情节，追更不错过每个名场面。',
    keywords:
      '泡在我家的辣妹分集剧情,泡在我家的辣妹剧情,泡在我家的辣妹看点,泡在我家的辣妹各话,泡在我家的辣妹更新',
    canonicalPath: '/episodes',
    jsonLd,
  });

  return (
    <>
      <PageHeader
        eyebrow="分集剧情"
        icon="ri-list-check-2"
        title="泡在我家的辣妹分集剧情"
        description="按顺序逐话整理剧情梗概与看点，方便你在看漫画前快速补课，也能帮你回顾错过的关键情节与名场面。"
        breadcrumbs={[{ label: '首页', to: '/' }, { label: '分集剧情' }]}
      />

      <section className="bg-background-50 py-14 md:py-16">
        <div className="container-site">
          <div className="space-y-4">
            {episodes.map((ep, idx) => (
              <article
                key={ep.id}
                className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 lg:flex-row lg:items-start"
              >
                <div className="flex shrink-0 items-center gap-3">
                  <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-500 font-heading text-base text-background-50">
                    第{ep.no}话
                  </span>
                  <span className="font-heading text-3xl text-background-300 lg:hidden">0{ep.no}</span>
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-3">
                    <h2 className="text-base font-semibold text-foreground-950 md:text-lg">{ep.title}</h2>
                    {idx === episodes.length - 1 && (
                      <span className="whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
                        最新更新
                      </span>
                    )}
                  </div>
                  <p className="mt-2 text-sm leading-7 text-foreground-700">{ep.summary}</p>
                  <p className="mt-3 inline-flex items-center gap-2 rounded-md bg-secondary-100 px-3 py-2 text-xs font-medium text-secondary-900">
                    <i className="ri-sparkling-2-line" />
                    {ep.highlight}
                  </p>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-12 rounded-lg bg-accent-100 p-8 text-center">
            <h2 className="font-heading text-xl md:text-2xl">想先了解整体脉络？</h2>
            <p className="mx-auto mt-3 max-w-xl text-sm leading-7 text-foreground-700">
              分集太多看得眼花？先从剧情主线入手，整体把握故事的走向，再看分集会更从容。
            </p>
            <Link
              to="/plot"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              查看故事主线
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}